import React from 'react'
import Body from './HomePage/Body'
import Navbar from './HomePage/Navbar'
import Footer from './HomePage/Footer'

function LandingPage() {
  return (
    <>
    <Navbar />
    <Body />
    <Footer />
    </>
  )
}

export default LandingPage
